import { DateDisplayFormat } from './date-display-format.enum';
import { NumberDisplayFormat } from './number-display-format.enum';
import { PhoneNumberDisplayFormat } from './phone-number-display-format.enum';
import { TimeDisplayFormat } from './time-display-format.enum';

/** Dropdown option shape before localization is applied. */
export interface LocalizationFormatOption<TValue> {
  value: TValue;
  labelKey: string;
}

export const DATE_FORMAT_OPTIONS: LocalizationFormatOption<DateDisplayFormat>[] = [
  {
    value: DateDisplayFormat.DayMonthYear,
    labelKey: 'Settings::Localization:DateFormat:DayMonthYear',
  },
  {
    value: DateDisplayFormat.MonthDayYear,
    labelKey: 'Settings::Localization:DateFormat:MonthDayYear',
  },
  {
    value: DateDisplayFormat.YearMonthDay,
    labelKey: 'Settings::Localization:DateFormat:YearMonthDay',
  },
];

export const TIME_FORMAT_OPTIONS: LocalizationFormatOption<TimeDisplayFormat>[] = [
  {
    value: TimeDisplayFormat.TwentyFourHour,
    labelKey: 'Settings::Localization:TimeFormat:TwentyFourHour',
  },
  {
    value: TimeDisplayFormat.TwelveHour,
    labelKey: 'Settings::Localization:TimeFormat:TwelveHour',
  },
];

export const PHONE_NUMBER_FORMAT_OPTIONS: LocalizationFormatOption<PhoneNumberDisplayFormat>[] = [
  {
    value: PhoneNumberDisplayFormat.International,
    labelKey: 'Settings::Localization:PhoneNumberFormat:International',
  },
  {
    value: PhoneNumberDisplayFormat.Local,
    labelKey: 'Settings::Localization:PhoneNumberFormat:Local',
  },
  {
    value: PhoneNumberDisplayFormat.DigitsOnly,
    labelKey: 'Settings::Localization:PhoneNumberFormat:DigitsOnly',
  },
];

export const NUMBER_FORMAT_OPTIONS: LocalizationFormatOption<NumberDisplayFormat>[] = [
  {
    value: NumberDisplayFormat.DotThousandCommaDecimal,
    labelKey: 'Settings::Localization:NumberFormat:DotThousandCommaDecimal',
  },
  {
    value: NumberDisplayFormat.CommaThousandDotDecimal,
    labelKey: 'Settings::Localization:NumberFormat:CommaThousandDotDecimal',
  },
];
